/**
 * Value for controlled MUI `type="number"` fields: preserve empty input
 * and avoid forcing a leading zero while the user is typing.
 */
export function numberInputDisplayValue(v) {
  if (v === "" || v === null || v === undefined) return "";
  if (typeof v === "number") {
    if (Number.isNaN(v)) return "";
    return v;
  }
  const n = Number(v);
  if (Number.isNaN(n)) return "";
  return n;
}
